import { Component, Input, WritableSignal } from '@angular/core';

@Component({
  selector: 'ln-full-screen-modal',
  imports: [],
  templateUrl: './full-screen-modal.component.html',
  styleUrl: './full-screen-modal.component.css',
})
export class FullScreenModalComponent {
  @Input({ required: true }) present!: WritableSignal<boolean>;
}
